import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useHistory, Link } from 'react-router-dom';

import PbxContext from '../../../context/PbxContext';

import { accessLocalStorage, valuesAnalyze, changeViewForms, registerUser, exportSelectAllQueues, exportSelectAllEndpoints, validEmail, readAllTenant } from '../../../services';

import Loading from '../../../components/Loading/LoadingModule';
import FormUser from './components/CreateUserForm';

import '../../../libs/bulma.min.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhoneSquare } from '@fortawesome/free-solid-svg-icons';

function UserCreate() {
  const getItensStateGlobal = useContext(PbxContext);
  const { toggleIsHidden, toggleIsChangeFormElements } = getItensStateGlobal;

  let url = window.location.href;
  url = url.split('/')[2];

  const history = useHistory();

  const [loading, setLoading] = useState(true);
  const [values, setValues] = useState({ active: true });
  const [validate, setValidate] = useState({});
  const [disable, setDisable] = useState(true);
  const [endpoints, setEndpoints] = useState([]);
  const [queues, setQueues] = useState([]);
  const [tenants, setTenants] = useState([]);
  const [views, setViews] = useState([]);

  const { changeBorderImputToRedOrNormal, changeVisibityMessages} = changeViewForms;

  const validateUserLogged = useCallback(async () => {
    const dataUser = accessLocalStorage.getUserLocalStorage();
    const { user: { role } } = dataUser;
    if (!dataUser) return history.push('/');
    if (dataUser && role !== 'root') return history.push('/home');
    const fetchQueues = await exportSelectAllQueues();
    const fetchEndpoints = await exportSelectAllEndpoints();
    const fetchTenants = await readAllTenant();

    const itensEndpoints = fetchEndpoints.map((item) => item.endpoint).filter((e) => !isNaN(e));
    const itensQueues = fetchQueues.map((queue) => queue.queuesselect);

    setEndpoints(itensEndpoints);
    setQueues(itensQueues);
    setTenants(fetchTenants);

    return setLoading(false);
  }, []);

  const changeScreen = (check, name) => {
    changeBorderImputToRedOrNormal(check, name);
    changeVisibityMessages(check, `${name}-invalid-data`);
  };

  const handleChangeDataAnalyze = (name, value) => {
    const { checkNumber, checkPassword, isTextAndSpace, checkText } = valuesAnalyze;

    if(name === 'endpointsviewer') {
      if (value === 'all' || value === 'none') return true;
      let checkValueIsNumber = checkNumber(value);
      changeScreen(checkValueIsNumber, name);
      return checkValueIsNumber;
    };

    if(name === 'email') {
      const emailIsValid = validEmail(value);
      changeScreen(emailIsValid, name);
      return emailIsValid;
    }

    if(name === 'password') {
      const passwordIsValid = checkPassword(value);
      changeScreen(passwordIsValid, name);
      return passwordIsValid;
    }

    if(name === 'role' || name === 'queuesviewer') {
      const checkValueIsCharacters = checkText(value);
      changeScreen(checkValueIsCharacters, name);
      console.log(checkValueIsCharacters)
      return checkValueIsCharacters;
    }
    
    if(name == 'name') {
      const checkValueIsCharacters = isTextAndSpace(value);
      changeScreen(checkValueIsCharacters, name);
      console.log(checkValueIsCharacters)
      return checkValueIsCharacters;
    }
    
    if(name == 'tenant') {
      const tenantsId = tenants.map((tenant) => tenant.short_name);
      const checkRealTenant = tenantsId.includes(value);
      console.log(checkRealTenant)
      changeScreen(checkRealTenant, name);
      return checkRealTenant;
    }
  };

  const handleChangeValues = (item) => {
    const { name, value } = item;

    const itemStatus = handleChangeDataAnalyze(name, value);
    setValidate((prevState) => prevState, validate[name] = itemStatus === undefined  ? true : itemStatus);
    name === 'endpointsviewer' || name === 'queuesviewer' ? setValues((prevState) => prevState, values[name] = Array.from(item.selectedOptions, (option) => option.value)) : setValues((prevState) => prevState, values[name] = value )
    if(Object.keys(validate).length === 8) Object.values(validate).includes(false) ? setDisable(true) : setDisable(false);
    return;
  };

  const endpointsViewerAnalyse = () => {
    if (values['endpointsviewer']) values['endpointsviewer'].includes('all') ? values['endpointsviewer'] = ['all'] : null;
    if (values['endpointsviewer']) values['endpointsviewer'].includes('none') ? values['endpointsviewer'] = ['none'] : null;
    if (values['endpointsviewer']) values['endpointsviewer'].includes('all') && values['endpointsviewer'].includes('none') ? values['endpointsviewer'] = ['none'] : null;
    return;
  }

  const queuesViewerAnalyse = () => {
    if (values['queuesviewer']) values['queuesviewer'].includes('all') ? values['queuesviewer'] = ['all'] : null;
    if (values['queuesviewer']) values['queuesviewer'].includes('none') ? values['queuesviewer'] = ['none'] : null;
    if (values['queuesviewer']) values['queuesviewer'].includes('all') && values['queuesviewer'].includes('none') ? values['queuesviewer'] = ['none'] : null;
    return;
  }

  const sendDataUsersGenerate = async () => {
    endpointsViewerAnalyse();
    queuesViewerAnalyse();

    const fetchEndpoints = await registerUser(values);
    toggleIsChangeFormElements('alert-create-users', 'is-hidden');
    const result = Object.keys(fetchEndpoints).length > 0 ? true : false;
    if(result) {
      setLoading(false);
      changeVisibityMessages(true, 'create-form');
      changeVisibityMessages(true, 'button-send-form');
      changeVisibityMessages(false, 'success-create-users');
      setTimeout(() => {
        return window.location.reload(true)
      }, 3000);
    };
    // console.log('Teste Novo: ', fetchEndpoints);
    return;
  };

  useEffect(() => {
    validateUserLogged();
  }, [validateUserLogged]);

  return (
    <div>
      {
        loading ?
          <Loading />
        :
        <div>
          <div className="columns">
            <div className="column is-half is-offset-one-quarter has-text-centered">
              <strong className="is-size-3">ADICIONAR USUÁRIO</strong>
              <hr className="dropdown-divider"/>
            </div>
          </div>
          <article id="alert-create-users" name="alert-create-users" className="column is-half is-offset-one-quarter message is-danger is-hidden">
            <div className="message-header">
              <p>Atenção!</p>
              <button className="delete" aria-label="delete" onClick={ () => toggleIsHidden('#alert-create-users') }></button>
            </div>
            <div className="message-body">
              Não é possível gerar usuário com os campos abaixo não preenchidos.
              <br />
              Por favor, verifique os dados e clique novamente no botão <strong>Adicionar Usuário</strong> 
            </div>
          </article>
          <article id="error-create-endpoints" name="error-create-endpoints" className="column is-half is-offset-one-quarter message is-danger is-hidden">
            <div className="message-header">
              <p>Erro!</p>
              <button className="delete" aria-label="delete" onClick={ () => toggleIsHidden('#error-create-endpoints') }></button>
            </div>
            <div className="message-body">
              Não foi possível criar o usuário!
              <br />
              Verifique se já existe usuário com o e-mail informado!
            </div>
          </article>
          <article id="success-create-users" name="success-create-users" className="column is-half is-offset-one-quarter message is-info is-hidden">
            <div className="message-header">
              <p>Sucesso!</p>
              <button className="delete" aria-label="delete" onClick={ () => toggleIsHidden('#success-create-users') }></button>
            </div>
            <div className="message-body">
              Usuário criado com <strong>sucesso</strong>!
            </div>
          </article>
          <div id="create-form">
            <FormUser endpoints={ endpoints } queues={ queues } tenants={ tenants } changeValues={ handleChangeValues } />
          </div>
          <div id="button-send-form" name="button-send-form" className="columns mt-3">
            <div className="field column mt-3 is-half is-offset-3 has-text-centered">
              <div className="control">
                <button className="button is-info is-fullwidth mt-3" type="submit" onClick={ () => sendDataUsersGenerate() } disabled={ disable }>
                  <span className="icon">
                    <FontAwesomeIcon icon={ faPhoneSquare } fixedWidth />
                  </span>
                  <span>
                    Adicionar Usuário
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  );
}

export default UserCreate;
